import { render, staticRenderFns } from "./roundItem.vue?vue&type=template&id=ddec550e&scoped=true&"
import script from "./roundItem.vue?vue&type=script&lang=ts&"
export * from "./roundItem.vue?vue&type=script&lang=ts&"
import style0 from "./roundItem.vue?vue&type=style&index=0&id=ddec550e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddec550e",
  null
  
)

export default component.exports